import { PARENT_CATEGORIES } from './parentCategory';
import { moisturizerItems, cleanserItems, maskItems, sunCareItems, maskPackItems } from './category';

export type ProductOption = {
  label: string;
  value: string;
};

// Create combined product options for the dropdown
export const PRODUCT_OPTIONS: ProductOption[] = [
  // Add "All products" as the first option
  { label: 'All products', value: 'all' },

  // Add parent categories
  ...PARENT_CATEGORIES.map((category) => ({
    label: category.name,
    value: category.url.replace('/collections/', '').replace('/', ''),
  })),

  // Add specific subcategories from each parent category
  ...moisturizerItems.map((item) => ({
    label: item.name,
    value: item.url.split('/').filter(Boolean).pop() || '',
  })),

  ...cleanserItems.map((item) => ({
    label: item.name,
    value: item.url.split('/').filter(Boolean).pop() || '',
  })),

  ...maskItems.map((item) => ({
    label: item.name,
    value: item.url.split('/').filter(Boolean).pop() || '',
  })),

  ...sunCareItems.map((item) => ({
    label: item.name,
    value: item.url.split('/').filter(Boolean).pop() || '',
  })),

  ...maskPackItems.map((item) => ({
    label: item.name,
    value: item.url.split('/').filter(Boolean).pop() || '',
  })),
];
